// Editor application entry point
import { EditorApp } from './editor/app.js';
import { PhotoStatusOverlay } from './editor/photo_status_overlay.js';

// Make EditorApp and PhotoStatusOverlay available globally for initialization and testing
window.EditorApp = EditorApp;
window.PhotoStatusOverlay = PhotoStatusOverlay;

// Initialize the app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.editorApp = new EditorApp();
  window.editorApp.init();
});

